/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper/bundle'; // import Swiper bundle with all modules installed
import accordion from './jquery.accordion.js'

(($) => {

    //MAIN HERO SLIDESHOW
    var mainSwiper = new Swiper('.js-home-slideshow', {
		effect: 'fade',
		loop: true,
		parallax: true,
        autoplay: false,
		navigation: false,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			hideOnclick: false,
			clickable: true
		}
    });

    const galleries = document.querySelectorAll('.gallery');

    // GALLERY SWIPER
    galleries.forEach((gallery, index) => {
        let slider = gallery.querySelector('.js-gallery-slides');
        let thumbs = gallery.querySelector('.js-gallery-thumbs');

        let contentSlider = gallery.querySelector('.js-gallery-slides-content');
        let contentPagination = gallery.querySelector('.swiper-pagination');

        const galleryThumbs = new Swiper(thumbs, {
            spaceBetween: 15,
            slidesPerView: 'auto',
            loop: false,
            freeMode: true
        });

        const galleryTop = new Swiper(slider, {
            loop: false,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });

        // INTERIOR GALLERY SWIPER w/ TEXT
        const galleryText = new Swiper(contentSlider, {
            loop: true,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            pagination: {
                el: contentPagination,
                type: 'bullets',
                hideOnclick: false,
                clickable: true
            }
        });

    });

    /* TABBED GALLERY
    **************************************************************/
    var swiperTabsNav = Swiper;
    var swiperTabsContent = Swiper;
    var init = false;
    $.fn.accordion = accordion
    $('dl.accordion--tabs').accordion('accordion--tabs', 'span');

    /* Which media query
    **************************************************************/
    function swiperMode() {
        let mobileMenu = window.matchMedia('(min-width: 0) and (max-width: 1023px)');
        let desktop = window.matchMedia('(min-width: 1024px)');

        // Enable (for desktop)
        if(desktop.matches) {
            if (!init) {
                $('dl.accordion--tabs dd.accordion__content').css('display', '');
                init = true;
                // TABBED GALLERY w/ TEXT
                // Swiper Tabs
                swiperTabsNav = new Swiper('.swiper-tabs-nav', {
                    spaceBetween: 45,
                    loop: false,
                    autoHeight: false,
                    resistanceRatio: 0,
                    watchOverflow: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    touchRatio: 0 //disable the drag touch event and leave the click touch event enabled
                });

                // Swiper Content
                swiperTabsContent = new Swiper('.swiper-tabs-content', {
                    spaceBetween: 0,
                    loop:false,
                    autoHeight: true,
                    longSwipes: true,
                    resistanceRatio: 0, // Disable First and Last Swiper
                    watchOverflow: true,
                    thumbs: {
                        swiper: swiperTabsNav,
                    },
                });
            }
        }

        // Disable (for tablet and mobile)
        else if(mobileMenu.matches && init === true) {
                swiperTabsNav.destroy();
                swiperTabsContent.destroy();
            init = false;
        }

    }

    /* On Load
    **************************************************************/
    window.addEventListener('load', function() {
        swiperMode();
    });

    /* On Resize
    **************************************************************/
    window.addEventListener('resize', function() {
        swiperMode();
    });

})(jQuery)